/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SharedContactDetailsQueryVariables = {
    slug: string;
};
export type SharedContactDetailsQueryResponse = {
    readonly contactShow: {
        readonly slug: string;
        readonly roles: ReadonlyArray<string>;
        readonly sharedDrivers: ReadonlyArray<any>;
        readonly sharedTransporters: ReadonlyArray<any>;
    };
};
export type SharedContactDetailsQuery = {
    readonly response: SharedContactDetailsQueryResponse;
    readonly variables: SharedContactDetailsQueryVariables;
};



/*
query SharedContactDetailsQuery(
  $slug: String!
) {
  contactShow(slug: $slug) {
    slug
    roles
    sharedDrivers
    sharedTransporters
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedDrivers",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedTransporters",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedContactDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SharedContactDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f28208c2b335f3c8c57f8a719fa6c762",
    "id": null,
    "metadata": {},
    "name": "SharedContactDetailsQuery",
    "operationKind": "query",
    "text": "query SharedContactDetailsQuery(\n  $slug: String!\n) {\n  contactShow(slug: $slug) {\n    slug\n    roles\n    sharedDrivers\n    sharedTransporters\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ea9503f3ada2ffd1d41d3112ed65ee4b';
export default node;
